import { GiReceiveMoney } from "react-icons/gi";
import { MdOutlineAutoGraph, MdAppShortcut } from "react-icons/md";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import Reveal from "./Reveal";

const cards = [
  {
    header: "Maximize Revenue",
    text: "Guaranteed income from your live event with an unlimited audience.",
    icon: GiReceiveMoney,
  },
  {
    header: "Control & Flexibility",
    text: "Set your own prices and release dates, ensuring full control over your content.",
    icon: MdAppShortcut,
  },
  {
    header: "Audience Engagement",
    text: "Create a sense of exclusivity and urgency, driving higher viewer engagement.",
    icon: AiOutlineUsergroupAdd,
  },
  {
    header: "Audience-Driven Ticket Sales",
    text: "Gain new fans and audiences through AYOZAT and our partners' ecosystem.",
    icon: MdOutlineAutoGraph,
  },
];

const BenefitCards = () => {
  return (
    <div className="mx-auto mb-24 grid w-full max-w-6xl grid-cols-4 gap-5 max-md:grid-cols-2 max-sm:grid-cols-1">
      {cards.map((card, i) => {
        const Icon = card.icon;
        return (
          <Reveal key={card.header} delay={i * 90} className="h-full">
            <div className="group h-full rounded-2xl border border-white/10 bg-white/[0.03] p-7 text-center backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-[var(--red)]/40 hover:bg-white/[0.05]">
              <div className="mx-auto mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-[var(--red)]/15 text-[var(--red)] transition-colors duration-300 group-hover:bg-[var(--red)] group-hover:text-white">
                <Icon size={22} />
              </div>
              <h3 className="mb-2 text-[17px] font-bold text-white">
                {card.header}
              </h3>
              <p className="text-[13.5px] leading-relaxed text-white/55">
                {card.text}
              </p>
            </div>
          </Reveal>
        );
      })}
    </div>
  );
};

export default BenefitCards;
